/**
 * 이메일 찾기 폼: Form.ts로 AJAX 제출.
 * 성공 시 masked_emails를 결과 영역에 표시, 실패 시 에러 박스에 표시.
 * Form must have id="auth-forgot-email-form" and data-submit-url.
 */
import { Form } from "../../core/Form";

const FORM_ID = "auth-forgot-email-form";
const ERROR_BOX_ID = "auth-forgot-email-error";
const RESULT_BOX_ID = "auth-forgot-email-result";

function getErrorBox(): HTMLElement | null {
  return document.getElementById(ERROR_BOX_ID);
}

function getResultBox(): HTMLElement | null {
  return document.getElementById(RESULT_BOX_ID);
}

function showError(message: string | null): void {
  const box = getErrorBox();
  if (!box) return;
  if (message === null || message === "") {
    box.innerHTML = "";
    box.hidden = true;
    return;
  }
  box.textContent = message;
  box.hidden = false;
}

function showResult(maskedEmails: string[], foundTitle: string): void {
  const box = getResultBox();
  if (!box) return;
  showError(null);
  if (maskedEmails.length === 0) {
    box.hidden = true;
    box.innerHTML = "";
    return;
  }
  const title = document.createElement("strong");
  title.textContent = foundTitle;
  title.style.display = "block";
  title.style.marginBottom = "0.5rem";
  const list = document.createElement("ul");
  list.style.margin = "0";
  list.style.paddingLeft = "1.25rem";
  maskedEmails.forEach((email) => {
    const li = document.createElement("li");
    li.textContent = email;
    list.appendChild(li);
  });
  box.innerHTML = "";
  box.appendChild(title);
  box.appendChild(list);
  box.hidden = false;
}

function getFirstError(errors: Record<string, string[]> | undefined): string {
  if (!errors || typeof errors !== "object") return "";
  const first = Object.values(errors).flat()[0];
  return typeof first === "string" ? first : "";
}

function isKo(): boolean {
  return document.documentElement.lang?.startsWith("ko") ?? false;
}

export function initAuthForgotEmailForm(): void {
  const form = document.getElementById(FORM_ID) as HTMLFormElement | null;
  if (!form) return;

  const submitUrl = form.dataset.submitUrl ?? form.action;
  if (!submitUrl) return;

  new Form(form, {
    submitUrl,
    submitButtonSelector: "button[type=submit]",
    loaderSelector: ".auth-page__btn-loader",
    requestFailedMessage: isKo() ? "요청을 보낼 수 없습니다." : "Request failed.",
    invalidResponseMessage: isKo() ? "응답을 처리할 수 없습니다." : "Invalid response.",
    onSuccess: (data) => {
      const maskedEmails = (data?.data as { masked_emails?: string[] } | undefined)?.masked_emails ?? [];
      const foundTitle = (data?.message ?? data?.msg ?? (isKo() ? "등록된 이메일" : "Registered email")) as string;
      showResult(Array.isArray(maskedEmails) ? maskedEmails : [], foundTitle);
    },
    onFail: (message, data) => {
      const errors = data?.errors as Record<string, string[]> | undefined;
      const first = getFirstError(errors);
      showError(first || message || "");
      getResultBox() && (getResultBox()!.hidden = true);
    },
  }).init();

  form.addEventListener("submit", () => {
    showError(null);
    const resultBox = getResultBox();
    if (resultBox) resultBox.hidden = true;
  });
}
